var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    numberFilterTree: 2,
    filterTreeMobileStyle: "style1",
    swatchStyle: "square-grid",
    extraSortingList: boostPFSAppConfig.general.default_sort_by,
    paginationTypeAdvanced: false,
    showPlaceholderProductList: true,
    placeholderImageRatio: 1.4, //It is used for ratio of image area  of Skeleton product item. (height / width)
    placeholderProductGridItemClass:
      "Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk", //In case the theme have grid/list mode, we need to define the classes for Product Grid mode.
    placeholderProductPerRow: 4,
    enableSeo: true,
    
  },
  labels: {
    badgeShape: 'shape-pill',   // 'shape-square' | 'shape-rounded' | 'shape-pill'
    badgeColors: {
      sale: { bg: '#FF0000', text: '#FFF' },
      save: { bg: '#FF0000', text: '#FFF' },
      new: { bg: '#000000', text: '#FFF' },
      low: { bg: '#FF832B', text: '#FFF' },
      off: { bg: '#FFD700', text: '#000' },
      sold_out: { bg: '#AAA', text: '#333' },
      coming_soon: { bg: '#ff7b00ff', text: '#ffffffff' },
    },
  }
};

// Create and inject a <style> tag if it hasn't been added already
// Create and inject a <style> tag if it hasn't been added already
if (!document.getElementById('custom-badge-styles')) {
  const style = document.createElement('style');
  style.id = 'custom-badge-styles';

  // 1) Base + shape variants
  style.innerHTML = `
    .badge--custom {
      font-size: 0.75rem;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding: 0.15rem 0.5rem;
      display: inline-block;
      box-shadow: unset;
    }
    .badge--custom.shape-square  { border-radius: 0; }
    .badge--custom.shape-rounded { border-radius: 6px; }
    .badge--custom.shape-pill    { border-radius: 50px; }

    @media (max-width: 600px) {
      .badge--custom {
        font-size: 0.5rem;
        padding: 0.1rem 0.3rem;
      }
    }
  `;

  // 2) Dynamic color classes from your badgeColors map
  const colors = boostPFSFilterConfig.labels.badgeColors || {};
  Object.entries(colors).forEach(([key, { bg, text }]) => {
    style.innerHTML += `
    /* only apply to our custom badges */
    .badge--custom.badge--${key} {
      background-color: ${bg} !important;
      color: ${text} !important;
    }
  `;
  });


  document.head.appendChild(style);
}


(function () {
  BoostPFS.inject(this);

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }
  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    //Add class
    itemHtml = itemHtml.replace(
      /{{mobileRow}}/g,
      boostPFSConfig.custom.mobile_row
    );
    itemHtml = itemHtml.replace(
      /{{tabletRow}}/g,
      boostPFSConfig.custom.tablet_row
    );
    itemHtml = itemHtml.replace(
      /{{desktopRow}}/g,
      boostPFSConfig.custom.desktop_row
    );

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }
     itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz(data));
    itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
    itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

    if (typeof Utils.compileShopifyProductVariables == "function") {
      itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
    }

    if (typeof Utils.compileShopifyProductMetafield == "function") {
      itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
    }
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildClass() {
    return boostPFSThemeConfig.custom.filter_position == "drawer"
      ? "lap-and-up"
      : "desk";
  }

  function buildClassHiz(data) {
    var productClass = boostPFSThemeConfig.custom.use_horizontal
      ? "ProductItem--horizontal"
      : "";
    if (soldOut) {
      productClass += " sold-out ";
    }
    return productClass;
  }

  function buildButtonSecond() {
    return boostPFSThemeConfig.custom.use_horizontal
      ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' +
          boostPFSThemeConfig.label.view_product +
          "</a>"
      : "";
  }

  function buildImage(data, images) {
    var htmlImg = "";
    if (images.length > 0) {
      var use_natural_size = false;
      var has_alternate_image = false;
      var has_main_image = false;
      var defaultMainImage = "";
      var defaultHoverImage = "";
      var one_image_per_variant =
        data.options_with_values[0].values.length == images.length ||
        data.options_with_values[0].values.length == images.length - 1;
      for (var i = 0; i < images.length; i++) {
        if (images[i]["alt"] && images[i]["alt"].includes("**main**")) {
          defaultMainImage = images[i];
          has_main_image = defaultMainImage;
        }
        if (
          boostPFSThemeConfig.custom.product_show_secondary_image &&
          images[i]["alt"] &&
          images[i]["alt"].includes("**hover**") &&
          !boostPFSThemeConfig.custom.use_horizontal
        ) {
          defaultHoverImage = images[i];
        }
      }

      if (one_image_per_variant && has_main_image && !defaultHoverImage)
        defaultHoverImage = has_main_image;

      htmlImg +=
        '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage ';
      if (
        boostPFSThemeConfig.custom.product_image_size == "natural" ||
        boostPFSThemeConfig.custom.use_horizontal
      )
        use_natural_size = true;
      //if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal)
      //  has_alternate_image = true;
      if (has_alternate_image)
        htmlImg += "ProductItem__ImageWrapper--withAlternateImage";
      htmlImg += '">';
      if (defaultMainImage) {
        var max_width = defaultMainImage.width;
      } else {
        var max_width = images[0].width;
      }
      if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
      var withCall = use_natural_size
        ? "withFallback"
        : boostPFSThemeConfig.custom.product_image_size;
      htmlImg +=
        '<div class="AspectRatio AspectRatio--' +
        withCall +
        '" style="max-width: ' +
        max_width +
        "px;";
      if (defaultMainImage) {
        var aspect_ratio = defaultMainImage.width / defaultMainImage.height;
      } else {
        var aspect_ratio = images[0].width / images[0].height;
      }
      if (use_natural_size) {
        htmlImg += "padding-bottom: " + 100 / aspect_ratio + "%;";
      }
      htmlImg += " --aspect-ratio: " + aspect_ratio + '">';

      if (images.length > 1) {
        var sizes = "200,300,400,600,800,900,1000,1200";
        console.log(defaultHoverImage);
        if (defaultHoverImage) {
          var support_size = imageSize(sizes, defaultHoverImage);
          var thumbUrl = Utils.optimizeImage(
            defaultHoverImage["src"],
            "{width}x"
          );
          htmlImg +=
            '<img test test class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' +
            thumbUrl +
            '" data-widths="[' +
            support_size +
            ']" data-sizes="auto" alt="' +
            data.title +
            '" data-image-id="' +
            defaultHoverImage.id +
            '">';
        } else {
          var support_size = imageSize(sizes, images[0]);
          var thumbUrl = Utils.optimizeImage(images[0]["src"], "{width}x");
          htmlImg +=
            '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' +
            thumbUrl +
            '" data-widths="[' +
            support_size +
            ']" data-sizes="auto" alt="' +
            data.title +
            '" data-image-id="' +
            images[0].id +
            '">';
        }
      }

      var sizes_main = "200,400,600,700,800,900,1000,1200";
      if (defaultMainImage) {
        var support_size = imageSize(sizes_main, defaultMainImage);
        var itemThumbUrl =
          images.length > 0
            ? defaultMainImage["src"]
            : boostPFSAppConfig.general.no_image_url;
      } else {
        var support_size = imageSize(sizes_main, images[0]);
        var itemThumbUrl =
          images.length > 0
            ? images[0]["src"]
            : boostPFSAppConfig.general.no_image_url;
      }

      var selectedColors = "";
      if (Globals.queryParams.hasOwnProperty("pf_opt_color")) {
        selectedColors = Globals.queryParams.pf_opt_color;
      } else if (Globals.queryParams.hasOwnProperty("pf_t_color_tag")) {
        selectedColors = Globals.queryParams.pf_t_color_tag;
      }
      for (var k = 0; k < selectedColors.length; k++) {
        var selectedColor = "";
        if (Globals.queryParams.hasOwnProperty("pf_opt_color")) {
          selectedColor = selectedColors[k].toLowerCase();
        } else if (Globals.queryParams.hasOwnProperty("pf_t_color_tag")) {
          selectedColor = selectedColors[k].toLowerCase().replace("color:", "");
        }
        for (var i = 0; i < data.variants.length; i++) {
          var variant = data["variants"][i];
          if (
            variant.hasOwnProperty("merged_options") &&
            variant["merged_options"].length > 0
          ) {
            for (var j = 0; j < variant["merged_options"].length; j++) {
              var mergeValue = variant["merged_options"][j].toLowerCase();
              if (mergeValue.indexOf(selectedColor) > -1) {
                var itemThumbUrl = variant["image"];
                break;
              }
            }
          }
        }
      }
      if (images.length <= 1) {
        htmlImg +=
          '<img class="ProductItem__Image test2 ProductItem__Image--alternate Image--fadeIn lazyautosizes Image--lazyLoaded" src="' +
          Utils.optimizeImage(images[0]["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
      }
      if (defaultMainImage) {
        htmlImg +=
          '<img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" src="' +
          Utils.optimizeImage(defaultMainImage["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
        htmlImg += '<span class="Image__Loader"></span>';
        htmlImg += "<noscript>";
        htmlImg +=
          '<img class="ProductItem__Image test3 ProductItem__Image--alternate" src="' +
          Utils.optimizeImage(defaultMainImage["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
        htmlImg +=
          '<img class="ProductItem__Image" src="' +
          Utils.optimizeImage(defaultMainImage["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
      } else {
        htmlImg +=
          '<img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" src="' +
          Utils.optimizeImage(images[0]["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
        htmlImg += '<span class="Image__Loader"></span>';
        htmlImg += "<noscript>";
        htmlImg +=
          '<img class="ProductItem__Image ProductItem__Image--alternate" src="' +
          Utils.optimizeImage(images[0]["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
        htmlImg +=
          '<img class="ProductItem__Image" src="' +
          Utils.optimizeImage(images[0]["src"], "600x") +
          '" alt="' +
          data.title +
          '">';
      }

      htmlImg += "</noscript>";
      htmlImg += "</div>";
      htmlImg += "</a>";
    } else {
      htmlImg +=
        '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">';
      htmlImg +=
        '<img class="ProductItem__Image" src="' +
        boostPFSAppConfig.general.no_image_url +
        '" alt="' +
        data.title +
        '">';
      htmlImg += '<span class="Image__Loader"></span>';
      htmlImg += "<noscript>";
      //     htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
      htmlImg +=
        '<img class="ProductItem__Image" src="' +
        boostPFSAppConfig.general.no_image_url +
        '" alt="' +
        data.title +
        '">';
      htmlImg += "</noscript>";
      htmlImg += "</div>";
      htmlImg += "</a>";
    }
    return htmlImg;
  }

  function imageSize(sizes, image) {
    if (image) {
      var desired_sizes = sizes.split(",");
      var supported_sizes = "";
      for (var k = 0; k < desired_sizes.length; k++) {
        var size = desired_sizes[k];
        var size_as_int = size * 1;
        if (image.width < size_as_int) {
          break;
        }
        supported_sizes = supported_sizes + size + ",";
      }

      if (supported_sizes == "") supported_sizes = image.width;

      if (!jQ.isNumeric(supported_sizes)) {
        supported_sizes = supported_sizes.split(",").join(",");
        supported_sizes = supported_sizes.substring(
          0,
          supported_sizes.lastIndexOf(",")
        );
      }
      return supported_sizes;
    } else {
      return "";
    }
  }

  function buildPrice(data) {
    var html = "";
    var show_price_on_hover =
      boostPFSThemeConfig.custom.product_show_price_on_hover;
    var classPriceHover = show_price_on_hover
      ? "ProductItem__PriceList--showOnHover"
      : "";

    // Calculate whole sale price
    var discountWholeSale = 0;
    var wholesale = false;
    var price_key = "";
    if (boostPFSAppConfig.general.customer_tags) {
      for (var i in boostPFSAppConfig.general.customer_tags) {
        var tag = boostPFSAppConfig.general.customer_tags[i];
        var key = "discount_" + tag;
        if (Utils.getProductMetafield(data, "sawholesale", key) !== null) {
          if (
            discountWholeSale <
            Utils.getProductMetafield(data, "sawholesale", key)
          )
            discountWholeSale = Utils.getProductMetafield(
              data,
              "sawholesale",
              key
            );
          wholesale = true;
          price_key = "price_" + tag;
        }
      }
    }
    if (data.available) {
      var priceMinAvailable;
      var compareMinAvailable;
      var saw_price_min = -1;
      for (var i in data.variants) {
        var variant = data.variants[i];
        if (variant.available) {
          if (!priceMinAvailable || priceMinAvailable > variant.price) {
            priceMinAvailable = variant.price;
          }
          if (variant.compare_at_price) {
            if (
              !compareMinAvailable ||
              compareMinAvailable > variant.compare_at_price
            ) {
              compareMinAvailable = variant.compare_at_price;
            }
          }
          if (Utils.getProductMetafield(data, variant.id, price_key) !== null) {
            if (saw_price_min == -1) {
              saw_price_min = Utils.getProductMetafield(
                data,
                variant.id,
                price_key
              );
            } else {
              if (
                saw_price_min >
                Utils.getProductMetafield(data, variant.id, price_key)
              ) {
                saw_price_min = Utils.getProductMetafield(
                  data,
                  variant.id,
                  price_key
                );
              }
            }
          }
        }
      }

      if (wholesale && saw_price_min == priceMinAvailable) {
        wholesale = false;
      }

      html +=
        '<div class="ProductItem__PriceList ' +
        classPriceHover +
        ' Heading" data-product-id="' +
        data.id +
        '">';
      if (wholesale) {
        var formatted_min_price =
          boostPFSAppConfig.general.sawholesale == "compare_at_price" &&
          compareMinAvailable != null
            ? compareMinAvailable
            : priceMinAvailable;
        var discount_price =
          (formatted_min_price * (100 - discountWholeSale)) / 100;
        if (priceVaries) {
          html +=
            '<span class="ProductItem__Price Price Text--subdued" style="color: #000;">' +
            boostPFSThemeConfig.label.from.replace(
              /{{min_price}}/g,
              Utils.formatMoney(discount_price, Globals.moneyFormat)
            ) +
            "</span>";
        } else {
          html +=
            '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' +
            Utils.formatMoney(discount_price, Globals.moneyFormat) +
            "</span>";
          html +=
            '<span class="ProductItem__Price Price Price--compareAt Text--subdued 1" data-money-convertible>' +
            Utils.formatMoney(formatted_min_price, Globals.moneyFormat) +
            "</span>";
        }
      } else {
        if (compareMinAvailable > priceMinAvailable) {
          if (priceMinAvailable != data.price_max) {
            html +=
              '<span class="ProductItem__Price Price Text--subdued"  style="color: #f05423;">' +
              boostPFSThemeConfig.label.from.replace(
                /{{min_price}}/g,
                Utils.formatMoney(priceMinAvailable)
              ) +
              "</span>";
          } else {
            html +=
              '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' +
              Utils.formatMoney(priceMinAvailable) +
              "</span> ";
            html +=
              '<span class="ProductItem__Price Price Price--compareAt Text--subdued 2" data-money-convertible>' +
              Utils.formatMoney(compareMinAvailable) +
              "</span>";
          }
        } else {
          if (priceMinAvailable != data.price_max) {
            html +=
              '<span class="ProductItem__Price Price  test Text--subdued">' +
              boostPFSThemeConfig.label.from.replace(
                /{{min_price}}/g,
                Utils.formatMoney(priceMinAvailable)
              ) +
              "</span>";
          } else {
            html +=
              '<span class="ProductItem__Price Price Text--subdued " data-money-convertible>' +
              Utils.formatMoney(priceMinAvailable) +
              "</span>";
          }
        }
      }
    } else {
      var saw_price_min = -1;
      for (var i in data.variants) {
        var variant = data.variants[i];
        if (Utils.getProductMetafield(data, variant.id, price_key) !== null) {
          if (saw_price_min == -1) {
            saw_price_min = Utils.getProductMetafield(
              data,
              variant.id,
              price_key
            );
          } else {
            if (
              saw_price_min >
              Utils.getProductMetafield(data, variant.id, price_key)
            ) {
              saw_price_min = Utils.getProductMetafield(
                data,
                variant.id,
                price_key
              );
            }
          }
        }
      }

      let availableVariants = data.variants.filter(
        (variant) => variant.available
      );

      if (availableVariants.length > 0) {
        let lowetAvailPrice = availableVariants[0].price;
        let lowetAvailComparePrice = availableVariants[0].compare_at_price;
        for (let i = 0; i < availableVariants.length; i++) {
          if (lowetAvailPrice > availableVariants[i].price)
            lowetAvailPrice = availableVariants[i].price;
          if (lowetAvailComparePrice > availableVariants[i].compare_at_price)
            lowetAvailComparePrice = availableVariants[i].compare_at_price;
        }

        if (wholesale && saw_price_min == firstVariant.price) {
          wholesale = false;
        }

        html +=
          '<div class="ProductItem__PriceList ' +
          classPriceHover +
          ' Heading" data-product-id="{{itemId}}">';

        let availVariantsPriceVaries = availableVariants.some(
          (availableVariant) =>
            availableVariant.price != availableVariants[0].price
        );
        // console.log(availableVariants, availVariantsPriceVaries)

        if (wholesale) {
          var formatted_min_price =
            boostPFSAppConfig.general.sawholesale == "compare_at_price" &&
            lowetAvailComparePrice != null
              ? lowetAvailComparePrice
              : alowetAvailPrice;
          var discount_price =
            (formatted_min_price * (100 - discountWholeSale)) / 100;
          if (availVariantsPriceVaries) {
            html +=
              '<span class="ProductItem__Price Price Text--subdued" style="color: #000;">' +
              boostPFSThemeConfig.label.from.replace(
                /{{min_price}}/g,
                Utils.formatMoney(discount_price, Globals.moneyFormat)
              ) +
              "</span>";
          } else {
            html +=
              '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' +
              Utils.formatMoney(discount_price, Globals.moneyFormat) +
              "</span>";
            html +=
              '<span class="ProductItem__Price Price Price--compareAt Text--subdued 3" data-money-convertible>' +
              Utils.formatMoney(formatted_min_price, Globals.moneyFormat) +
              "</span>";
          }
        } else {
          if (lowetAvailComparePrice > lowetAvailPrice) {
            // if (priceVaries && firstVariant.price > 0) {
            //     html += '<span class="ProductItem__Price Price Text--subdued" style="color: #f05423;">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(firstVariant.price)) + '</span>';
            // Start Boost 215608
            //     html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued 6" data-money-convertible>' + Utils.formatMoney(firstVariant.compare_at_price) + '</span>';
            // End Boost 215608
            // } else {
            //     html += '<span class="ProductItem__Price Price Price--highlight Text--subdued 4" data-money-convertible> From ' + Utils.formatMoney(firstVariant.price) + '</span> ';
            html +=
              '<span class="ProductItem__Price Price Text--subdued 22" style="color: #f05423;">' +
              Utils.formatMoney(lowetAvailPrice) +
              "</span>";
            html +=
              '<span class="ProductItem__Price Price Price--compareAt Text--subdued 5" data-money-convertible>' +
              Utils.formatMoney(lowetAvailComparePrice) +
              "</span>";
          } else {
            if (availVariantsPriceVaries) {
              html +=
                '<span class="ProductItem__Price Price Text--subdued" style="color: #f05423;">' +
                boostPFSThemeConfig.label.from.replace(
                  /{{min_price}}/g,
                  Utils.formatMoney(lowetAvailPrice)
                ) +
                "</span>";
            } else {
              html +=
                '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' +
                Utils.formatMoney(lowetAvailPrice) +
                "</span>";
            }
          }
        }
      }
    }
    html += "</div>";

    return html;
  }

  
  /* =========================================================
     CONFIG
     ========================================================= */
  const COMING_SOON_CFG = {
    shop: 'fxr-racing-se',                           // <-- your shop
    token: '85b1525bdf2a665bf4fda56919dc24a3',            // <-- storefront token
    namespace: 'custom',
    key: 'coming_soon_regions',
    text: (boostPFSThemeConfig?.label?.coming_soon || 'Coming Soon'),
    ttlMs: 5 * 60 * 1000, // cache TTL (5 min)
    maxConcurrency: 4,     // concurrent GraphQL requests
    maxRetries: 2          // retry count for 5xx/429 or network errors
  };

  /* =========================================================
     SMALL UTILS
     ========================================================= */
  function toGid(id) {
    const s = String(id || '');
    return s.startsWith('gid://') ? s : `gid://shopify/Product/${s}`;
  }
  function safeCssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/[^a-zA-Z0-9_-]/g, '_');
  }
  function isMeaningful(val) {
    const t = String(val ?? '').trim();
    return t.length && t !== '-'; // treat "-" as empty
  }

  /* =========================================================
     BOOST CHECK (SYNC)
     ========================================================= */
  function hasBoostComingSoon(product) {
    const v = (product?.metafields || [])
      .find(m => m.namespace === COMING_SOON_CFG.namespace && m.key === COMING_SOON_CFG.key)
      ?.value;
    return isMeaningful(v);
  }

  /* =========================================================
     LIGHTWEIGHT REQUEST POOL + CACHE (TTL)
     ========================================================= */
  const _metaCache = new Map(); // key -> { promise, ts }
  let _inflight = 0;
  const _queue = [];

  function _withPool(fn) {
  return new Promise((resolve, reject) => {
    _queue.push({ fn, resolve, reject });
    _runNext();
  });
}

function _runNext() {
  if (_inflight >= COMING_SOON_CFG.maxConcurrency || _queue.length === 0) return;
  _inflight++;
  const { fn, resolve, reject } = _queue.shift();

  Promise.resolve()
    .then(fn)                  // run the job
    .then(resolve, reject)     // forward result or error
    .finally(() => {
      _inflight--;
      _runNext();
    });
}

  /* =========================================================
     NETWORK: FETCH METAFIELD ONCE (CACHED + RETRIES)
     ========================================================= */
function fetchComingSoonOnce(productId) {
  const { shop, token, namespace, key, ttlMs, maxRetries } = COMING_SOON_CFG;
  if (!productId || !shop || !token) return Promise.resolve(null);

  const gid = toGid(productId);
  const cacheKey = `${shop}|${gid}|${namespace}|${key}`;

  const cached = _metaCache.get(cacheKey);
  if (cached && Date.now() - cached.ts < ttlMs) return cached.promise;

  const query = `
    query Product {
      product(id: "${gid}") {
        metafield(namespace: "${namespace}", key: "${key}") {
         value 
         }
      }
    }
  `;

  const attempt = async (n = 0) => {
    const r = await fetch(`https://${shop}.myshopify.com/api/2025-07/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query })
    });

    if (!r.ok) {
      const body = await r.clone().text().catch(() => '');
      console.warn('HTTP error', r.status, body);
      if (n < maxRetries && (r.status === 429 || (r.status >= 500 && r.status < 600))) {
        await new Promise(rs => setTimeout(rs, 100 * 2 ** n));
        return attempt(n + 1);
      }
      return null;
    }

    const j = await r.json().catch(() => null);
    if (!j) return null;
    if (Array.isArray(j.errors) && j.errors.length) {
      console.warn('GraphQL errors', j.errors);
      return null;
    }
    const v = j?.data?.product?.metafield?.value ?? null;
    return isMeaningful(v) ? v : null;
  };

  const promise = _withPool(() => attempt());
  _metaCache.set(cacheKey, { promise, ts: Date.now() });
  return promise;
}


  /* =========================================================
     UPGRADE BADGE IN-PLACE (ASYNC, NON-BLOCKING)
     ========================================================= */
  function upgradeBadgeIfComingSoon(product, {
    lowClass = 'badge--sold_out',
    comingClass = 'badge--coming_soon',
    comingText = COMING_SOON_CFG.text
  } = {}) {
    

   
    fetchComingSoonOnce(product?.id).then(value => {
      if (!isMeaningful(value)) return;

      
      const sel = `[data-role="badge-${safeCssEscape(product?.id)}"]`;
      let tries = 0;
      
      const tryUpgrade = () => {
        tries++;
        const el = document.querySelector(sel);
        if (el) {
          el.classList.remove(lowClass);
          
          el.classList.add(comingClass);
          el.textContent = comingText;
        } else if (tries < 10) {
          requestAnimationFrame(tryUpgrade); // wait for mount
        }
      };

      requestAnimationFrame(tryUpgrade);
    }).catch(() => { /* silent fail */ });
  }


  /* ================
     Build Labels (SYNC)
     ================ */



  function buildLabels(data) {
    let html = '';
    let product_labels = '';

    const product = data


    const handle = boostPFSAppConfig.general.collection_handle;

    const { badgeShape } = boostPFSFilterConfig.labels;
    

    const additionalCollections = Array.isArray(boostPFSAppConfig.general.additionalCollections)
      ? boostPFSAppConfig.general.additionalCollections
      : [];

    // const collectionEligible =
    //   handle === "snow-all-current" ||     // exact match
    //   handle.includes("sale") ||           // any handle containing "sale"
    //   additionalCollections.includes(handle); // whitelist lookup


      const saleStockPromotion = handle.includes("sale") || handle.includes("black-friday");

    if (boostPFSThemeConfig.custom.show_labels) {



      const productVariants = data.variants;

      let availableQty = 0;
      for (let i = 0; i < productVariants.length; i++) {
        const variant = productVariants[i];
        if (variant && typeof variant.inventory_quantity === 'number') {
          availableQty += variant.inventory_quantity;
        }
      }

      const savingsAmount = data.compare_at_price_max - data.price_min;
      const multipleSalePrices = data.price_max !== data.price_min;
      const onSale = data.compare_at_price_max > data.price_min;
      const soldOut = data.available === false;

      const isBelow100 = data.price_min < 100;

      const locale = boostPFSAppConfig.general.locale || 'en';
      const langVal = boostPFSThemeConfig.label.off;
      const tags = data.tags;
      const isNewProduct = tags.includes("__label:New");

      const showLowStock = availableQty < 10 && saleStockPromotion;
      const showNew = isNewProduct;
      const showSale = onSale && saleStockPromotion;
      //     const comingSoon =  getComingSoonRegion(data, { shop, sT });

      // if (comingSoon) {
      //   product_labels += `
      //     <span class="badge--custom ${badgeShape} badge--comingsoon">
      //       Coming Soon
      //     </span>`;
      // }

      // 🥇 Priority: Coming soon> Sold Out > Low Stock > Sale > New
      if (soldOut) {
        // Sold Out overrides all
        if (hasBoostComingSoon(product)) {
          product_labels += `
    <span
      class="badge--custom ${badgeShape} badge--coming_soon"
      data-badge-for="${product.id}"
      data-badge-state="coming"
    >
      ${COMING_SOON_CFG.text}
    </span>`;
        } else {
          product_labels += `
                <span class="badge--custom ${badgeShape} badge--sold_out" data-role="badge-${product.id}">
                    ${boostPFSThemeConfig.label.sold_out}
                </span>`;
          // kick off non-blocking upgrade
          
          upgradeBadgeIfComingSoon(product);
         
        }

      } else if (showLowStock) {
        // Low Stock overrides Sale & New
       

        product_labels += `
                <span class="badge--custom ${badgeShape} badge--low">
                    ${boostPFSThemeConfig.label.low_in_stock}
                </span>`;
      } else if (showSale && showNew) {
        // On Sale + New → show only Sale
        if (multipleSalePrices) {
          product_labels += `
                    <span class="badge--custom ${badgeShape} badge--sale">
                        ${boostPFSThemeConfig.label.sale}
                    </span>`;
        } else {
          let savingsLabel = '';
          if (isBelow100) {
            const percentOff = Math.round((savingsAmount / data.compare_at_price_max) * 100);
            savingsLabel = langVal === '−' ? `− ${percentOff}%` : `${percentOff}% ${boostPFSThemeConfig.label.off}`;
          } else {
            savingsLabel = `${boostPFSThemeConfig.label.save} ${boostPFSThemeConfig.label.currency}  ${savingsAmount.toFixed(2)}`;
            
          }
          product_labels += `
                    <span class="badge--custom ${badgeShape} badge--save">
                        ${savingsLabel}
                    </span>`;
        }
      } else {
        // Normal badge logic when no conflicts
        if (showNew) {
          product_labels += `
                    <span class="badge--custom ${badgeShape} badge--new">
                        ${boostPFSThemeConfig.label.new}
                    </span>`;
        }
        if (showSale) {
          if (multipleSalePrices) {
            product_labels += `
                        <span class="badge--custom ${badgeShape} badge--sale">
                            ${boostPFSThemeConfig.label.sale}
                        </span>`;
          } else {
            let savingsLabel = '';
            if (isBelow100) {
              const percentOff = Math.round((savingsAmount / data.compare_at_price_max) * 100);
              savingsLabel = langVal === '−' ? `− ${percentOff}%` : `${percentOff}% ${boostPFSThemeConfig.label.off}`;
            } else {
              savingsLabel = `${boostPFSThemeConfig.label.save} ${boostPFSThemeConfig.label.currency} ${savingsAmount.toFixed(2)}`;
            }
            product_labels += `
                        <span class="badge--custom ${badgeShape} badge--save">
                            ${savingsLabel}
                        </span>`;
          }
        }
      }

      if (product_labels !== '') {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += '</div>';
      }
    }
    return html;
  }

  function buildInfo(data, indx) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="ProductItem__Info ' + infoClass + ' ">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
			}

			// html += '<h2 class="ProductItem__Title Heading">';
			// html += '<a href="{{itemUrl}}">' + data.title + '</a>';
			// html += '</h2>';        
			// html += '<span class="stamped-product-reviews-badge" data-id="{{itemId}}" data-product-sku="' + data.handle + '"></span>';
          	if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx, data.images_info);	
			}
			html += buildPrice(data);
			
          	html += buildCompareApp(data);
			html += '</div>';
		}

		return html;
	}

  function buildSwatch(data, indx, images) {
    var itemColorSwatchHtml = '';
    var imageSrc = '';
    var imageSrcOriginal = '';
  
    if (boostPFSThemeConfig?.custom?.show_color_swatch) {
      var colorOptionIndex = data.options_with_values.findIndex(function (opt) {
        var lower = opt.name.toLowerCase();
        return lower === 'colour' || lower === 'color' || lower === 'couleur';
      });
  
      if (colorOptionIndex === -1) {
        return '';
      }
      var colorOptionObj = data.options_with_values[colorOptionIndex];
      if (!colorOptionObj) {
        return '';
      }
      var one_image_per_variant = (
        data.options_with_values[0].values.length === images.length ||
        data.options_with_values[0].values.length === images.length - 1
      );
      
      itemColorSwatchHtml += '<div class="col-swatch" data-handle="' + data.handle + '">';
      itemColorSwatchHtml += '<ul data-option-index="' + colorOptionIndex + '" class="color options">';
  
      var colorValues = colorOptionObj.values; 
      for (var i = 0; i < colorValues.length; i++) {
        var value = colorValues[i].origin_title || colorValues[i].title;
  
        var colorVariants = data.variants.filter(function (variant) {
  
          var variantColor = variant.original_merged_options[colorOptionIndex] || '';
          variantColor = variantColor.replace(/^color:/i, '').trim().toLowerCase();
          return variantColor === value.toLowerCase();
        });
  
        if (!colorVariants || colorVariants.length === 0) {
          continue;
        }
  
        // 3) Check if ANY variant is in-stock
        // `variant.available` is a built-in Shopify property
        // If you track actual quantity, you could do: (v.inventory_quantity > 0)
        var atLeastOneInStock = colorVariants.some(function (v) {
          return v.available === true;
        });
  
        var chosenVariant = colorVariants.find(function (v) {
          return v.available === true;
        }) || colorVariants[0];
  
        if (chosenVariant?.image) {
          imageSrc = Utils.optimizeImage(chosenVariant.image, '42x42_crop_top');
          imageSrcOriginal = Utils.optimizeImage(chosenVariant.image);
        } else {
          imageSrc = boostPFSAppConfig.general.no_image_url;
          imageSrcOriginal = boostPFSAppConfig.general.no_image_url;
        }
  
        var hoverImage = imageSrcOriginal;
        if (chosenVariant.image && !one_image_per_variant) {
          images.forEach(function (img, index) {
            if (img.src === chosenVariant.image && images[index + 1]) {
              hoverImage = Utils.optimizeImage(images[index + 1].src);
            }
          });
        }
  
        // "Boost 163208" logic for backgrounds
        var bgEmpty = value;
        if (imageSrc) bgEmpty = 'none';
  
        // 4) Determine if the swatch is fully unavailable (none of its variants are in-stock)
        var liClass = 'color ' + Utils.slugify(value);
        if (!atLeastOneInStock) {
          liClass += ' unavailable'; 
        }
  
        var variantQty = chosenVariant.inventory_quantity || 0;
  
        // Build the <li>
        itemColorSwatchHtml += ''
          + '<li '
          +   'data-id="{{itemId}}" '
          +   'data-option-title="' + value + '" '
          +   'data-href-hover="' + hoverImage + '" '
          +   'data-href-image="' + imageSrcOriginal + '" '
          +   'data-stock="' + variantQty + '" '
          +   'class="' + liClass + '">'
          +     '<span '
          +       'style="background-color: ' + bgEmpty + '; '
          +              'background-image: url(' + imageSrc + ')">'
          +     '</span>'
          + '</li>';
      }
  
      // Close up the UL and container
      itemColorSwatchHtml += '</ul></div>';
  
      itemColorSwatchHtml += '<script>' +
        '$("#product-item-{{itemId}} .col-swatch li").each(function() {' +
        '  $(this).click(function(e) {' +
        '    if ($(this).hasClass("unavailable")) {' +
        '      e.preventDefault();' +
        '      return false;' +
        '    }' +
        '    $("#product-item-{{itemId}} .col-swatch li").removeClass("selected");' +
        '    $(this).addClass("selected");' +
        '    var newImage = $(this).attr("data-href-image");' +
        '    var hoverImage = $(this).attr("data-href-hover");' +
        '    var variantQty = $(this).attr("data-stock");' +
        '    $("#product-item-{{itemId}}").attr("data-stock", variantQty);' +
        '    $("#product-item-{{itemId}} .ProductItem__Image:nth-child(2)").attr({ srcset: newImage });' +
        '    $("#product-item-{{itemId}} .ProductItem__Image--alternate").attr({ srcset: hoverImage });' +
        '    return false;' +
        '  });' +
        '});' +
        '</script>';
    }
  
    return itemColorSwatchHtml;
  }
    

  function buildCompareApp(data) {
    var html = "";
    var collectIdList = "";

    for (var i = 0; i < data.collections.length; i++) {
      collectIdList += data.collections[i]["id"];
      if (i < data.collections.length) {
        collectIdList += ",";
      }
    }

    // Add Compare
    html += '<label class="SPCMP_chk_lbl" style="display:none;">';
    html +=
      '<input type="checkbox" class="SPCMP_Add " name="SPCMP_chk" spcmp_collids="' +
      collectIdList +
      '" spcmp_pid="' +
      data.id +
      '" spcmp_vid="' +
      data["variants"][0]["id"] +
      '">';
    html += '<span class="SPCMP_Add_span"></span>';
    html += "</label>";

    return html;
  }
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml =
        currentPage > 1
          ? boostPFSTemplate.previousActiveHtml
          : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (
      boostPFSThemeConfig.custom.show_sorting &&
      boostPFSTemplate.hasOwnProperty("sortingHtml")
    ) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          var classActive = Globals.queryParams.sort == k ? "is-selected" : "";
          sortingItemsHtml +=
            '<button class="Popover__Value ' +
            classActive +
            ' Heading Link Link--primary u-h6" data-value="' +
            k +
            '">' +
            sortingArr[k] +
            "</button>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var topSortingSelector = jQ(Selector.topSorting);
    topSortingSelector.find(".Popover__Value").click(function (e) {
      FilterApi.setParam("sort", jQ(this).data("value"));
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
      jQ(".CollectionToolbar__Item--sort").trigger("click");
    });
  };
  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    /**
		 *  Call theme function 
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
		
		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}  
		*/

    // Fix image not load on Instagram browser - initialize swatch image
    // 		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function() {
    // 			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
    // 			jQ(this).addClass('active');
    // 			var parent = jQ(this).parent();
    // 			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
    // 			var variantInfo = parent.find('input.ColorSwatch__Radio');
    // 			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
    // 			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
    // 			productImage.find('img.ProductItem__Image').hide();
    // 			productImage.attr('href', variantInfo.data('variant-url'));
    // 			var variantPrice = '';
    // 			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
    // 				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
    // 				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
    // 			} else {
    // 				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
    // 			}
    // 			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
    // 		})

    //Change view layout
    var desktopView = jQ(".CollectionToolbar__LayoutSwitch.hidden-phone")
      .find(".is-active")
      .data("count");
    if (
      desktopView &&
      desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)
    ) {
      jQ(Selector.products + " .Grid__Cell").removeClass(
        "1/" +
          boostPFSThemeConfig.custom.tablet_row +
          "--tablet-and-up 1/" +
          boostPFSThemeConfig.custom.desktop_row +
          "--" +
          buildClass()
      );
      jQ(Selector.products + " .Grid__Cell").addClass(
        "1/" +
          desktopView +
          "--tablet-and-up 1/" +
          desktopView +
          "--" +
          buildClass()
      );
    }
    var mobileView = jQ(".CollectionToolbar__LayoutSwitch.hidden-tablet-and-up")
      .find(".is-active")
      .data("count");
    if (
      mobileView &&
      mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)
    ) {
      jQ(Selector.products + " .Grid__Cell").removeClass(
        "1/" + boostPFSThemeConfig.custom.mobile_row + "--phone"
      );
      jQ(Selector.products + " .Grid__Cell").addClass(
        "1/" + mobileView + "--phone"
      );
    }

    if (typeof SACMP_included != "undefined") {
      if (typeof initSACMPJQuery != "undefined") {
        initSACMPJQuery();
      }
    }



    // Start Boost 205024
    function formRequest(value) {
      return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest
          ? new XMLHttpRequest()
          : new ActiveXObject("Microsoft.XMLHTTP");
        xhr.open("GET", value);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
      });
    }

    for (var item of data) {
      var valueRequest =
        Shopify.routes.root +
        "products/" +
        item.handle +
        "?view=boost-pfs-prod-prices";
      var requestReg = formRequest(valueRequest);
      requestReg
        .then((res_success) => {
          var parse_res_success = JSON.parse(res_success);
          console.log({ parse_res_success });
          var itemEl = jQ('[data-id="' + parse_res_success.id + '"]');
          console.log(itemEl)
          if (itemEl.length > 0) {
            itemEl
              .find(".ProductItem__PriceList")
              .html(buildPrice(parse_res_success));
          }
        })
        .catch((res_error) => {
          console.log(res_error);
        });
    }
    // End Boost 205024
  };

  // Build additional elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;

    swatchAvailability(data);

    if (bcSections != null) {
      bcSections.register("collection", bcWebpacks["CollectionSection"]);
    }

    if (eventType == "filter" || eventType == "clear") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;

    //       setTimeout(function(){
    //         jQ('.ProductItem .col-swatch').each(function(e){
    //           var $li = jQ(this).find('li').first();
    //           $li.trigger('click');
    //         })
    //       }, 500)
    //       	jQ('.ProductItem .col-swatch').each(function(e){
    //           var $li = jQ(this).find('li').first();
    //           $li.trigger('click');
    //         })
  };

  // Build Default layout
  Filter.prototype.errorFilterCallback = function () {
    var isiOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isSafari = /Safari/.test(navigator.userAgent),
      isBackButton =
        window.performance &&
        window.performance.navigation &&
        2 == window.performance.navigation.type;
    if (!(isiOS && isSafari && isBackButton)) {
      var self = this,
        url = window.location.href.split("?")[0],
        searchQuery =
          self.isSearchPage() && self.queryParams.hasOwnProperty("q")
            ? "&q=" + self.queryParams.q
            : "";
      window.location.replace(url + "?view=bc-original" + searchQuery);
    }
  };

  function swatchAvailability(data) {
    $.each($(".col-swatch"), function (i, val) {
      var this_product = $(this);
      $.ajax({
        type: "GET",
        url:
          "/products/" + this_product.data("handle") + "?view=metafields.json",
        success: function (response) {
          var swatchesAvailability = JSON.parse(response);
          const data_product = data.products.find(
            (item) => item.handle == this_product.data("handle")
          );
          const variants = data_product.variants;
          $.each(this_product.find("li"), function (i, val) {
            const currentVariant = variants.find(
              (item) => item.options[0] == $(this).data("option-title")
            );
            // Start boost 202363
            if (
              swatchesAvailability[$(this).data("option-title")]?.quantity &&
              swatchesAvailability[$(this).data("option-title")]?.quantity <= 0
            ) {
              if (currentVariant.inventory_policy != "continue") {
                $(this).addClass("out-stock");
                $(this).attr("data-stock", 0);
              } else {
                $(this).removeClass("out-stock");
                $(this).attr("data-stock", 1);
              }
              // End boost 202363
            } else {
              $(this).attr("data-stock", 1);
            }
            if (swatchesAvailability[$(this).data("option-title")]?.hidden) {
              $(this).addClass("hide");
            }
            if (swatchesAvailability[$(this).data("option-title")]?.disabled) {
              $(this).addClass("disabled");
            }
          });
        },
        error: function (err) {},
      });
    });
  }
  // ORIGINAL CODE FROM BOOST PFS -----

    FilterApi.beforeCall = function(eventType, eventInfo) {
      Globals.queryParams.product_available = false;
      Globals.queryParams.variant_available = false;
      Globals.queryParams.check_cache = false;
      // FXR Addition - If collection handle is 'custom', show ONLY out-of-stock products
      // Display both out of stock and in-stock for custom assests := design team unable to fulfill requests on some items (temp change)
      if (boostPFSAppConfig.general.collection_handle.includes('custom') || boostPFSAppConfig.general.collection_handle.includes('replica') ) {
      Globals.queryParams.pf_st_stock_status = ['false', 'true'];
        
      Globals.queryParams.pf_t_only_show_current_season = [];
    return;
      }
      // end 
    
      if (!Globals.queryParams.hasOwnProperty('pf_st_stock_status') && eventType == 'init') {
        Globals.queryParams.pf_st_stock_status= ['true'];
      }
      if (Globals.queryParams.hasOwnProperty('pf_st_stock_status') && Globals.queryParams.pf_st_stock_status.indexOf('false') !== -1 && eventType == 'init' && Globals.queryParams.pf_st_stock_status.indexOf('true') !== -1) {
        Globals.queryParams.pf_t_only_show_current_season = ['__label:Current'];
      }
      if (Globals.queryParams.hasOwnProperty('pf_st_stock_status') && Globals.queryParams.pf_st_stock_status.indexOf('false') !== -1 && typeof(eventInfo.filterOptionId) !== 'undefined' && eventInfo.filterOptionId == "pf_st_stock_status") {
        //console.log(eventInfo.filterOptionId);
        Globals.queryParams.pf_t_only_show_current_season = ['__label:Current'];
      }
      if(!!eventInfo && typeof(eventInfo.filterOptionId) !== 'undefined' && eventInfo.filterOptionId == 'pf_st_stock_status' && Globals.queryParams.hasOwnProperty('pf_st_stock_status') && Globals.queryParams.pf_st_stock_status.indexOf('false') == -1){
      	Globals.queryParams.pf_t_only_show_current_season = [];
      }
  
  // Exclude products based on product tag pfs:hidden:excludedByMAP
  if (boostPFSAppConfig.general.collection_handle.includes('sale')) {
    Globals.queryParams.h_options = "excludedByMAP";
  }   
    }

// // FXR Addition - Update Collection Rules for COMING SOON
//   FilterApi.beforeCall = function(eventType, eventInfo) {
//   Globals.queryParams.product_available = false;
//   Globals.queryParams.variant_available = false;
//   Globals.queryParams.check_cache = false;

//   // FXR Addition - If collection handle is 'custom' or 'replica', show BOTH out-of-stock and in-stock products
//   // Display both for custom assets/replica := design team unable to fulfill requests on some items (temp change)
//   if (boostPFSAppConfig.general.collection_handle.includes('custom') || boostPFSAppConfig.general.collection_handle.includes('replica')) {
//     Globals.queryParams.pf_st_stock_status = ['false', 'true'];
//     Globals.queryParams.pf_t_only_show_current_season = [];
//     return;
//   }

//   // NEW DEFAULT: On initial load (all other collections), show BOTH in-stock and out-of-stock
//   if (!Globals.queryParams.hasOwnProperty('pf_st_stock_status') && eventType == 'init') {
//     Globals.queryParams.pf_st_stock_status = ['false', 'true'];
//   }

//   // If BOTH are present at init, default season filter to Current
//   if (
//     Globals.queryParams.hasOwnProperty('pf_st_stock_status') &&
//     Globals.queryParams.pf_st_stock_status.indexOf('false') !== -1 &&
//     eventType == 'init' &&
//     Globals.queryParams.pf_st_stock_status.indexOf('true') !== -1
//   ) {
//     Globals.queryParams.pf_t_only_show_current_season = ['__label:Current'];
//   }

//   // If user toggles stock status to include 'false' via the filter UI, keep Current season
//   if (
//     Globals.queryParams.hasOwnProperty('pf_st_stock_status') &&
//     Globals.queryParams.pf_st_stock_status.indexOf('false') !== -1 &&
//     typeof(eventInfo?.filterOptionId) !== 'undefined' &&
//     eventInfo.filterOptionId == 'pf_st_stock_status'
//   ) {
//     Globals.queryParams.pf_t_only_show_current_season = ['__label:Current'];
//   }

//   // If user filters to ONLY in-stock (no 'false'), clear the season constraint
//   if (
//     !!eventInfo &&
//     typeof(eventInfo.filterOptionId) !== 'undefined' &&
//     eventInfo.filterOptionId == 'pf_st_stock_status' &&
//     Globals.queryParams.hasOwnProperty('pf_st_stock_status') &&
//     Globals.queryParams.pf_st_stock_status.indexOf('false') == -1
//   ) {
//     Globals.queryParams.pf_t_only_show_current_season = [];
//   }

//   // Exclude product based on product tag pfs:hidden:excludedByMAP on sale collections
//   if (boostPFSAppConfig.general.collection_handle.includes('sale')) {
//     Globals.queryParams.h_options = "excludedByMAP";
//   }
// }
RobotsMeta.prototype.render = function() {
		// jQ('head').append(this.compileTemplate());
}
})();